export interface MiqSavable {
  beforeSave(): void;
  afterSave(): void;
}

export const MiqSavableType: MiqSavable = {
  beforeSave: () => {
    throw new Error('Method not implemented.');
  },
  afterSave: () => {
    throw new Error('Method not implemented.');
  },
};
